<template>
  <BaseDataList ref="dataList" :items="contactRequests" :service="fetchContactRequests">
    <template #header>
      <ContactRequestListHeader />
    </template>

    <template #default="{ item }">
      <ContactRequestListItem :contact-request="item" />
    </template>
  </BaseDataList>
</template>

<script>
import { contactContactRequestsClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import ContactRequestListHeader from './ContactRequestListHeader.vue';
import ContactRequestListItem from './ContactRequestListItem.vue';

export default {
  components: {
    ContactRequestListHeader,
    ContactRequestListItem,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      contactRequests: [],
    };
  },
  methods: {
    async fetchContactRequests() {
      try {
        const response = await contactContactRequestsClient.list(this.contactId, {
          include: 'project,pipelineStage,user',
        });

        this.contactRequests = response.data.map(mapKeysToCamelCase);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
